export function timeout<T>(timeoutMs: number, promise: Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error(`Promise timeout (${timeoutMs}ms elapsed)`))
    }, timeoutMs)

    promise.then(
      res => {
        clearTimeout(timeoutId)
        resolve(res)
      },
      err => {
        clearTimeout(timeoutId)
        reject(err)
      },
    )
  })
}
